import styled from 'styled-components';
import { colours } from '@storefront/lib-global/stylings';
import { selectedCardStyle } from '../CardSelector/CardSelector';

export const OccasionSelectorImage = styled.button<{ $isSelected: boolean }>`
  border: ${({ $isSelected }) => ($isSelected ? `1px solid ${colours.BLACK}` : 'none')};
  cursor: pointer;
  height: 100%;
  padding: 1px;
  width: 100%;

  ${({ $isSelected }) => ($isSelected ? selectedCardStyle : null)}

  &:hover,
    &:focus {
    border: 1px solid ${colours.BLACK};
    padding: 0;
  }
`;
